// import { Analytics } from '@plaudit/analytics';
// const analytics = Analytics.getInstance();

import * as $ from 'jquery';
import 'slick-carousel';

// import '../../lib/slick-A11Y.js';


const slickCarousel = () => {
	// tripCarousel
	$(function () {
		let $items = $('.tripCarousel__items');

		$items.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 10000,
			arrows: true,
			centerMode: true,
			centerPadding: '60px',
			dots: false,
			pauseOnHover: false,
			adaptiveHeight: false,
			mobileFirst: true,
			responsive: [
				{ breakpoint: 580,
					settings: {
						centerPadding: '120px'
					}
				},
				{ breakpoint: 680,
					settings: {
						centerPadding: '160px'
					}
				},
				{ breakpoint: 780,
					settings: {
						centerPadding: '200px'
					}
				},
				{ breakpoint: 860,
					settings: {
						slidesToShow: 2,
						centerPadding: '120px'
					}
				},
				{ breakpoint: 1100,
					settings: {
						slidesToShow: 2,
						centerPadding: '190px'
					}
				},
				{ breakpoint: 1320,
					settings: {
						slidesToShow: 2,
						centerPadding: '260px'
					}
				}
			],
			nextArrow: '<button type="button" class="slick-next"><span>Next ›</span></button>',
			prevArrow: '<button type="button" class="slick-prev"><span>‹ Previous</span></button>',
		});
	});

	// testminonialCarousel
	$(function () {
		let $items = $('.testimonialCarousel__items');

		$items.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 10000,
			arrows: true,
			centerMode: true,
			centerPadding: '60px',
			dots: false,
			pauseOnHover: false,
			adaptiveHeight: false,
			mobileFirst: true,
			responsive: [
				{ breakpoint: 580,
					settings: {
						centerPadding: '120px'
					}
				},
				{ breakpoint: 680,
					settings: {
						centerPadding: '160px'
					}
				},
				{ breakpoint: 780,
					settings: {
						centerPadding: '200px'
					}
				},
				{ breakpoint: 860,
					settings: {
						slidesToShow: 2,
						centerPadding: '120px'
					}
				},
				{ breakpoint: 1100,
					settings: {
						slidesToShow: 2,
						centerPadding: '190px'
					}
				},
				{ breakpoint: 1320,
					settings: {
						slidesToShow: 2,
						centerPadding: '260px'
					}
				}
			],
			nextArrow: '<button type="button" class="slick-next"><span>Next ›</span></button>',
			prevArrow: '<button type="button" class="slick-prev"><span>‹ Previous</span></button>',
		});
	});

	// timelineCarousel
	$(function () {
		let $outer = $('.timeline');
		let $inner = $('.timeline__inner');
		let $items = $('.timeline__items');

		$items.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplaySpeed: 10000,
			arrows: true,
			dots: true,
			pauseOnHover: false,
			adaptiveHeight: false,
			customPaging: function (slider, i) {
				var title = $(slider.$slides[i]).find('[data-title]').data('title');
				return '<div class="year" data-year="' + title + '"><span>' + title + '</span></div>';
			},
			responsive: [
				{ breakpoint: 1150, settings: { slidesToShow: 1 } }
			],
			appendArrows: $inner,
			appendDots: $outer,
			dotsClass: 'timeline__nav',
			nextArrow: '<button type="button" class="slick-next"><span>Next ›</span></button>',
			prevArrow: '<button type="button" class="slick-prev"><span>‹ Previous</span></button>',
		});
		$items.on('swipe', function(event, slick, direction){
			//*GA*/analytics.trackEvent('Timeline Carousel', 'Swipe', direction);
		});
		$items.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			console.log(event);
			$outer.find('[role="tablist"]').attr('data-current', nextSlide);
			$outer.attr('data-year', nextSlide);
		});
		// NOTE: slickCarousel does not allow for proper A11Y designation because it uses "presentation"
	});
};

export default slickCarousel;
